import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setSucursal } from '../../Redux/actions/PageActions';
import { useHistory } from "react-router-dom";
import { useSucursal } from '../../Helpers/useSucursal';
import { ModalConfirmacionSucursal } from '../Checkout/Modales/modalConfirmacionSucursal.component';
import { responsiveFontSizes } from '@material-ui/core';

const ModalSucursales = ({ close, setClose, sucursales, setSucursales, myRef, sucursalesAll }) => {

    //poner el set
    const Allsucursales = sucursalesAll;
    const [currentBranch, setCurrentBranch] = useState({})
    const [showModal, setShowModal] = useState(false);
    const [validateBranch, setValidateBranch] = useState(false);


    useEffect(() => {
        if (validateBranch) {
            CambiarSucursal(currentBranch);
        }
    }, [validateBranch]);

    const dispatch = useDispatch();
    const { getValidarCatalogo } = useSucursal();
    let history = useHistory();

    const CambiarSucursal = sucursal => {
        //Se Valida el catalogo
        getValidarCatalogo(sucursal).then(
            response => {
                dispatch(setSucursal(sucursal));
                setValidateBranch(false);
                setShowModal(false);
            }
        ).finally(()=>{
            history.push('/');
        });
    }

    // var Slider = {
    //     position: 'absolute',
    //     backgroundColor: '#fff',
    //     width: '400px',
    //     padding: '2rem 0rem',
    //     height: '70vh',
    //     top: '3rem',
    //     overflow: 'hidden',
    //     right: '-4vw',
    //     opacity: '1',
    //     cursor: 'auto',
    //     borderRadius: ' 0 0 20px 20px',
    //     transition: 'all 0.5s',
    // }

    // var CloseSlider = {
    //     height: 0,
    //     right: '-4vw',
    //     top: '3.5rem',
    //     position: 'absolute',
    //     backgroundColor: '#fff',
    //     width: '400px',
    //     overflow: 'hidden',
    //     opacity: '1',
    //     transition: 'all 0.5s',
    // }

    const [term, setterm] = useState('')

    const Search = (term) => {
        if (term.trim() !== '') {
            const arraySearch = Array.from(Allsucursales)
            //let SearchRepositories=arraySearch.filter((surcursal)=>surcursal.nombre.toUpperCase().indexOf(term.toUpperCase()) >= 0 ||surcursal.codigo.toUpperCase().indexOf(term.toUpperCase()) >= 0);
            const SearchRepositories = arraySearch.filter(item => {
                return (
                    item.nombre.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
                    || item.codigo.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
                    || item.razonsocial.toLowerCase().trim().indexOf(term.toLowerCase().trim()) >= 0
                )
            })

            var results = SearchRepositories.splice(0, 6);
            setSucursales(results)
        } else {
            const arraySearch = Array.from(Allsucursales)
            let results = arraySearch.splice(0, 6);

            setSucursales(results)
        }
    }

    return (
        <>
            <div
                className={`slider ${close ? "" : "openSucursal"}`}
                ref={myRef}
            // style={close ? CloseSlider : Slider}
            >
                <div className="row">
                    <div className="input-group " style={{ margin: '0 2rem' }}>
                        <input className="form-control py-2 border-right-0 border shadow-none" placeholder='Buscar' style={{ backgroundColor: "#E1EEF6", color: "#0075bb", fontWeight: 'bold' , fontSize: '10px'}} type="search" value={term} onChange={(e) => { setterm(e.target.value); Search(e.target.value) }} id="example-search-input" />
                        <span className="input-group-append">
                            <button className="btn btn-outline-secondary border-left-0 border" type="button" style={{ backgroundColor: "#E1EEF6" , height: '29px' }}>
                                <i className="fa fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div>

                <div className="results overflow-auto scrollSlider">

                    {
                        sucursales.map((sucursal, i) => (
                            <div
                                key={`${i}sucursal}`}
                                className="result"
                                onClick={
                                    () => {
                                        setCurrentBranch(sucursal);
                                        setShowModal(true);
                                        setClose(!close);
                                    }
                                }>
                                <h6>{sucursal.codigo} - {sucursal.razonsocial}</h6>
                                <h6>Días de entrega {sucursal.diaEntrega}</h6>
                            </div>
                        ))
                    }

                </div>
                <div style={{ margin: '0 2rem' }} className="btn-results" onClick={() => {
                    history.push({
                        pathname: '/Sucursales',
                        state: {
                            sucursales: Allsucursales
                        }
                    })
                }}>
                    <h6 className="no-seleccionable">Ver todas las sucursales</h6>
                </div>
            </div>
            {
                showModal
                &&
                <ModalConfirmacionSucursal setShowModal={setShowModal} variable={validateBranch} setVariable={setValidateBranch} />
            }
        </>
    )
}

export default ModalSucursales;